declare var require: any;
export const environment = {
  production: false,
  name: require('../../package.json').name,
  applicationId: require('../../package.json').id,
  version: require('../../package.json').version,
  versionCode: require('../../package.json').versionCode,
  timezoneOffset: new Date().getTimezoneOffset() * 60 * 1000,
  proxyApiUrl: 'https://qahumming.cyfirma.com',
  firebase: {},
  google: {},
  xOrigin: {
    key: 'gAAAAABfz8c3n5zEaiu8-CqUrNfL5edYS7AuPPwuZyMte5yommiPKBwm2JvDVic4TA8b-kswxvabL6vgLpnjhIsFG_0J1RzTJcMHTcTlMcT_fcdC9t2QSqM=',
  },
};
